import axios from 'axios'
import VueCookie from 'vue-cookie'
const api = axios.create({
  baseURL: process.env.VUE_APP_URL,
  headers: {
    common: {
      'Authorization': `Bearer ${VueCookie.get(process.env.VUE_APP_TOKEN)}`,
      'x-pwa-version': process.env.VUE_APP_VERSION
    }
  }
})

export { api }
